'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (identifier) {
    // 已知的 key 直接返回
    if (typeof identifier === 'string' && PLATFORM_KEYS.indexOf(identifier) !== -1) {
        return identifier;
    }

    // 如果不是已知的 key，根据 ua 区分
    var ua = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf('cheniu') !== -1) {
        return 'PLATFORM_CHENIU';
    }

    if (ua.indexOf('dafengche') !== -1) {
        return 'PLATFORM_SELLERAPP';
    }

    if (ua.indexOf('sccworkbench') !== -1 || ua.indexOf('sccwk') !== -1) {
        return 'PLATFORM_SCCWK';
    }
    if (identifier) {
        console.warn('\u57CB\u70B9\u521D\u59CB\u5316\u7684platform\u5B57\u6BB5:' + identifier + '\u975E\u6CD5.\u8BF7\u5C3D\u5FEB\u6CE8\u518C,\u5426\u5219\u5C06\u65E0\u6CD5\u751F\u6548'); // eslint-disable-line
    }
    return identifier;
};

/*
 * 埋点 keys 文档
 * http://doc.souche-inc.com/pages/viewpage.action?pageId=3881681
 */
var PLATFORM_KEYS = ['PLATFORM_WEB', // 官网
'PLATFORM_H5', // 微店
'PLATFORM_CHENIU', // 车牛
'PLATFORM_WEIXIN', // 微信
'PLATFORM_AUCTION', // 拍卖
'PLATFORM_FINANCE', // 金融业务
'PLATFORM_TANGECHE', // 弹个车  已弃用
'PLATFORM_TGC_ANDROID', // 弹个车 APP 安卓
'PLATFORM_TGC_IOS', // 弹个车 APP ios
'PLATFORM_TGC_PC', // 弹个车
'PLATFORM_TGC_M', // 弹个车
'PLATFORM_TGC_WX', // 弹个车 微信小程序
'PLATFORM_TGC_MARKET', // 弹个车
'PLATFORM_TGC_ALIPAY_XIAOCHENGXU', // 弹个车
'PLATFORM_TGC_ALIPAY_OTHER', // 弹个车 PAY
'PLATFORM_TD', // 深度试驾
'PLATFROM_TANGECHE_WECHAT', // 微信
'PLATFORM_SCCWK', // 地推工作台
'GUARANTEE', // 担保交易
'PLATFORM_SELLERAPP', // 大风车-App
'ERP', // 大风车-ERP
'C2B_H5', // C2B M站
'C2B_IOS', // C2B IOS app
'C2B_ANDROID', // C2B 安卓app
'C2B_PC', // C2B PC端
'C2B_WECHAT', // C2B 微信小程序
'PLATFORM_MANUFACTURER_GRAND', // C2B 天猫广汇
'PLATFORM_SERVICE' // 基础平台
];

/**
 * [exports description]
 * @param  {string} identifier 标识符 （可以是平台需要的 key，也可以是 userAgent）
 * @return {string}            埋点所需要的平台 key
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/dist/platform_keys.js
// module id = 0oDG
// module chunks = 11